export default __webpack_public_path__ + "static/map/img/sense_logo.9d679e4.gif";